import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 10 minutes 48 seconds
  const [timeLeft, setTimeLeft] = useState(10 * 60 + 48);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const isUrgent = timeLeft < 120; // Less than 2 minutes
  return <div className="fixed top-0 left-0 w-full z-50 bg-[#DC2626] text-white py-2 px-4 shadow-md" data-id="element-223">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-bold" data-id="element-224">
        <Clock className={`w-5 h-5 ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-225" />
        <span className="uppercase tracking-wide hidden sm:inline" data-id="element-226">
          Esta oferta termina pronto:
        </span>
        <span className="uppercase tracking-wide sm:hidden" data-id="element-227">
          Oferta expira:
        </span>
        <div className={`font-mono text-lg bg-black/20 px-2 rounded ${isUrgent ? 'text-yellow-300 animate-pulse' : ''}`} data-id="element-228">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </div>
      </div>
    </div>;
}